import { render } from "./List.vue?vue&type=template&id=6761f7ae&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import "./List.vue?vue&type=style&index=0&id=6761f7ae&scoped=true&lang=css"

import exportComponent from "/var/www/html/tsk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6761f7ae"]])

export default __exports__